import { useEffect, useRef } from 'react'

export default function useModalHistory (isOpen, onClose, modalId = 'modal') {
  const hasAddedHistoryRef = useRef(false)
  const isClosingRef = useRef(false)

  useEffect(() => {
    if (isOpen && !hasAddedHistoryRef.current) {
      window.history.pushState({ modal: modalId, timestamp: Date.now() }, '', window.location.href)
      hasAddedHistoryRef.current = true
    }

    if (!isOpen && hasAddedHistoryRef.current && !isClosingRef.current) {
      hasAddedHistoryRef.current = false
    }
  }, [isOpen, modalId])

  useEffect(() => {
    const handlePopState = event => {
      if (isOpen && hasAddedHistoryRef.current) {
        event.preventDefault()

        isClosingRef.current = true

        onClose()

        hasAddedHistoryRef.current = false

        setTimeout(() => {
          isClosingRef.current = false
        }, 100)
      }
    }

    window.addEventListener('popstate', handlePopState)

    return () => {
      window.removeEventListener('popstate', handlePopState)

      if (hasAddedHistoryRef.current && isOpen) {
        window.history.back()
        hasAddedHistoryRef.current = false
      }
    }
  }, [isOpen, onClose])

  return null
}
